import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, ACCOUNTGROUP } from '../../../appconfig/Settings';

import { AccountTabs } from '../../Account/AccountTabs';
import { deleteDataWithParameters, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { CREATEACCOUNTGROUP, DELETEACCOUNTGROUP, GETACCOUNTGROUP } from '../../../config/ApiConstant';
import { AccountGroupListColumns } from '../../../appconfig/DatatableSetting';
import { AddUpdateAccountGroupValidate } from '../../../config/Validate';

export const AccountGroup = () => {
    document.title = 'Account Group Master | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [accountGroupList, setAccountGroupList] = useState<any>([]);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [accountGroupData, setAccountGroupData] = useState<any>({});
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getAccountGroupData();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get account group data
    const getAccountGroupData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(GETACCOUNTGROUP);
            if (response) {
                setPageLoad(true);
                setAccountGroupList(response.List);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button label="Add Account Group" icon="pi pi-plus" onClick={() => openAddAccountModal()} className="ml-2"></Button>
            </>
        );
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name == 'accGroup' || name === 'type') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAccountGroupData({ ...accountGroupData, [name]: val });
    };

    // Open add account modal
    const openAddAccountModal = () => {
        setAddUpdateModal(true);
    };

    // Open edit account modal
    const openEditAccountModal = (rowData: any) => {
        setEditId(rowData.SrNo);
        let accountGroup = ACCOUNTGROUP.filter((item: any) => Number(item.code) === Number(rowData.HeadSrNo));
        setAccountGroupData({
            accGroupNm: rowData.GroupName,
            accGroup: accountGroup.length > 0 ? accountGroup[0] : '',
            accSeq: rowData.Sequence
        });
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setEditId(null);
        setAccountGroupData({});
        setErrors({});
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
    };

    // On submit add update account group
    const onSubmitAddUpdateAccountGroup = async () => {
        try {
            const { errors, isError } = AddUpdateAccountGroupValidate(accountGroupData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //Request object
                let formData: any = new FormData();

                if (editId !== null) {
                    formData.append('SrNo', editId);
                }

                formData.append('GroupName', accountGroupData.accGroupNm);
                formData.append('HeadSrNo', accountGroupData.accGroup.code);
                formData.append('Sequence', accountGroupData.accSeq);

                //apicall
                const response = await postAllData(CREATEACCOUNTGROUP, formData);
                if (response && !window.cn(response)) {
                    setAccountGroupData({});
                    setEditId(null);
                    setAddUpdateLoader(false);
                    setAddUpdateModal(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                    setTimeout(() => {
                        getAccountGroupData();
                    }, 1500);
                }
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Something Went Wrong'
            });
        }
    };

    // Template for action
    const actionTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="Edit" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" onClick={() => openEditAccountModal(rowData)} />
                    <Button className="p-button-danger ml-2" tooltip="Delete" tooltipOptions={{ position: 'top' }} icon="pi pi-trash" onClick={() => openDeleteModal(rowData.SrNo)} />
                </div>
            </>
        );
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // Delete account group
    const deleteAccountGroup = async () => {
        try {
            setDeleteLoader(true);

            //apicall
            const response = await deleteDataWithParameters(DELETEACCOUNTGROUP + '?SrNo=' + deleteId);
            if (response && !window.cn(response)) {
                setDeleteId(null);
                setDeleteLoader(false);
                setDeleteModal(false);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                setTimeout(() => {
                    getAccountGroupData();
                }, 1500);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Something Went Wrong'
            });
        }
    };

    return (
        <>
            <AccountTabs mainTabLabel="Account Group" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={accountGroupList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={accountGroupList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Data Found"
                                >
                                    {AccountGroupListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AccountGroupListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '90vh' }}
                header={editId !== null ? 'Edit Account Group' : 'Add Account Group'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" className="p-button-secondary" icon="pi pi-times" onClick={closeAddUpdateModal} />
                        <Button label="Submit" className="p-button-primary" icon="pi pi-check" onClick={() => onSubmitAddUpdateAccountGroup()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-6">
                        <label htmlFor="accGroupNm">
                            Group Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={accountGroupData?.accGroupNm} name="accGroupNm" autoComplete="off" placeholder="Enter Account Group Name" onChange={(e) => onInputChange(e, 'accGroupNm')} className={errors['accGroupNm'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['accGroupNm']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="accSeq">
                            Sequence <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputNumber value={accountGroupData?.accSeq} name="accSeq" useGrouping={false} placeholder="Enter Sequence" onChange={(e) => onInputChange(e, 'accSeq')} className={errors['accSeq'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['accSeq']}</small>
                    </div>
                    <div className="field col-12">
                        <label htmlFor="accGroup">
                            Account Group <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={accountGroupData?.accGroup}
                            name="accGroup"
                            options={ACCOUNTGROUP}
                            filter
                            optionLabel="name"
                            placeholder="Select Account Group"
                            onChange={(e) => onInputChange(e.value, 'accGroup')}
                            className={errors['accGroup'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['accGroup']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Account Group"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteAccountGroup} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Account Group, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
